<template>
  <div class="checkStep">
    <!-- <el-button class="checkBtn">查看项目进度</el-button> -->
    <!-- 项目进度弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
      class="stepDia"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <!-- <span class="title-name" style="color:#128BF1;margin-right:5px">张某某-</span> -->
        <span class="title-age">项目进度</span>
      </div>
      <div class="configRow">
        <!-- 只是申请此项目编号 时不展示 -->
        <el-button v-if="!is_demand_type" @click="handleChangeStepClick">调整项目阶段</el-button>
      </div>
      <div class="diaHistoryBox">
        <el-timeline class="projectTime">
          <!-- reg -->
          <el-timeline-item
            :class="projectLog.reg.length>0?'eltimelinefocus':'eltimelineNofocus'"
            timestamp="立项"
            placement="top"
          >
            <div v-for="items in projectLog.reg">
              <div v-for="item in items">
                <div class="stepItem" style="width:80%">
                  <p
                    class="overflowHiddenText"
                    style="width:37%"
                  >{{item.stage_code_show.split('-')[1]}}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-if="item.approval_status != '0' && item.executorInfo"
                  >{{item.add_time+' ' + item.executorInfo.nickname }}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-else-if="item.approval_status == '0'"
                  >
                    <span class="step_row_uesername_for" v-for="itemsss in item.tomemberInfo">
                      <span v-if="itemsss.nickname">{{itemsss.nickname}}</span>
                    </span>
                  </p>
                  <p style="width:45%" v-else></p>
                  <p
                    class="overflowHiddenText"
                    style="width:13%;display:flex;justify-content: flex-end; color:#128BF1;margin-left:30px"
                  >
                    <span style="color: rgb(48, 173, 95)" v-if="item.approval_status=='0'">待审批</span>
                    <span style="color:rgb(18, 139, 241)" v-if="item.approval_status=='1'">通过</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-1'">驳回</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-2'">撤回</span>
                  </p>
                </div>
                <p v-if="item.remark" style="margin-bottom:20px;padding-left: 50px;font-size:16px">
                  <span>备注:</span>
                  <span style="margin-left:15px;color:rgb(255, 51, 51)">{{item.remark}}</span>
                </p>
              </div>
            </div>
          </el-timeline-item>
          <!-- scene (只是申请项目编号时不展示)-->
          <el-timeline-item
            v-if="!is_demand_type"
            :class="projectLog.scene.length>0?'eltimelinefocus':'eltimelineNofocus'"
            timestamp="现场调查"
            placement="top"
          >
            <div v-for="items in projectLog.scene">
              <div v-for="item in items">
                <div class="stepItem" style="width:80%">
                  <p
                    class="overflowHiddenText"
                    style="width:37%"
                  >{{item.stage_code_show.split('-')[1]}}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-if="item.approval_status != '0' && item.executorInfo"
                  >{{item.add_time+' ' + item.executorInfo.nickname }}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-else-if="item.approval_status == '0'"
                  >
                    <span class="step_row_uesername_for" v-for="itemsss in item.tomemberInfo">
                      <span v-if="itemsss.nickname">{{itemsss.nickname}}</span>
                    </span>
                  </p>
                  <p style="width:45%" v-else></p>
                  <p
                    class="overflowHiddenText"
                    style="width:13%;display:flex;justify-content: flex-end; color:#128BF1;margin-left:30px"
                  >
                    <span style="color: rgb(48, 173, 95)" v-if="item.approval_status=='0'">待审批</span>
                    <span style="color:rgb(18, 139, 241)" v-if="item.approval_status=='1'">通过</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-1'">驳回</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-2'">撤回</span>
                  </p>
                </div>
                <p v-if="item.remark" style="margin-bottom:20px;padding-left: 50px;font-size:16px">
                  <span>备注:</span>
                  <span style="margin-left:15px;color:rgb(255, 51, 51)">{{item.remark}}</span>
                </p>
              </div>
            </div>
          </el-timeline-item>
          <!-- audit (只是申请项目编号时不展示) -->
          <el-timeline-item
            v-if="!is_demand_type"
            :class="projectLog.audit.length>0?'eltimelinefocus':'eltimelineNofocus'"
            timestamp="三级审查"
            placement="top"
          >
            <div v-for="items in projectLog.audit">
              <div v-for="item in items">
                <div class="stepItem" style="width:80%">
                  <p
                    class="overflowHiddenText"
                    style="width:37%"
                  >{{item.stage_code_show.split('-')[1]}}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-if="item.approval_status != '0' && item.executorInfo"
                  >{{item.add_time+' ' + item.executorInfo.nickname }}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-else-if="item.approval_status == '0'"
                  >
                    <span class="step_row_uesername_for" v-for="itemsss in item.tomemberInfo">
                      <span v-if="itemsss.nickname">{{itemsss.nickname}}</span>
                    </span>
                  </p>
                  <p style="width:45%" v-else></p>
                  <p
                    class="overflowHiddenText"
                    style="width:13%;display:flex;justify-content: flex-end; color:#128BF1;margin-left:30px"
                  >
                    <span style="color: rgb(48, 173, 95)" v-if="item.approval_status=='0'">待审批</span>
                    <span style="color:rgb(18, 139, 241)" v-if="item.approval_status=='1'">通过</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-1'">驳回</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-2'">撤回</span>
                  </p>
                </div>
                <p v-if="item.remark" style="margin-bottom:20px;padding-left: 50px;font-size:16px">
                  <span>备注:</span>
                  <span style="margin-left:15px;color:rgb(255, 51, 51)">{{item.remark}}</span>
                </p>
              </div>
            </div>
          </el-timeline-item>
          <!-- out (只是申请项目编号时不展示) -->
          <el-timeline-item
            v-if="!is_demand_type"
            :class="projectLog.out.length>0?'eltimelinefocus':'eltimelineNofocus'"
            timestamp="外部审查"
            placement="top"
          >
            <div v-for="items in projectLog.out">
              <div v-for="item in items">
                <div class="stepItem" style="width:80%">
                  <p
                    class="overflowHiddenText"
                    style="width:37%"
                  >{{item.stage_code_show.split('-')[1]}}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-if="item.approval_status != '0' && item.executorInfo"
                  >{{item.add_time+' ' + item.executorInfo.nickname }}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-else-if="item.approval_status == '0'"
                  >
                    <span class="step_row_uesername_for" v-for="itemsss in item.tomemberInfo">
                      <span v-if="itemsss.nickname">{{itemsss.nickname}}</span>
                    </span>
                  </p>
                  <p style="width:45%" v-else></p>
                  <p
                    class="overflowHiddenText"
                    style="width:13%;display:flex;justify-content: flex-end; color:#128BF1;margin-left:30px"
                  >
                    <span style="color: rgb(48, 173, 95)" v-if="item.approval_status=='0'">待审批</span>
                    <span style="color:rgb(18, 139, 241)" v-if="item.approval_status=='1'">通过</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-1'">驳回</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-2'">撤回</span>
                  </p>
                </div>
                <p v-if="item.remark" style="margin-bottom:20px;padding-left: 50px;font-size:16px">
                  <span>备注:</span>
                  <span style="margin-left:15px;color:rgb(255, 51, 51)">{{item.remark}}</span>
                </p>
              </div>
            </div>
          </el-timeline-item>
          <!-- seal (只是申请项目编号时不展示) -->
          <el-timeline-item
            v-if="!is_demand_type"
            :class="projectLog.seal.length>0?'eltimelinefocus':'eltimelineNofocus'"
            timestamp="报告盖章"
            placement="top"
          >
            <div v-for="items in projectLog.seal">
              <div v-for="item in items">
                <div class="stepItem" style="width:80%">
                  <p
                    class="overflowHiddenText"
                    style="width:37%"
                  >{{item.stage_code_show.split('-')[1]}}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-if="item.approval_status != '0' && item.executorInfo"
                  >{{item.add_time+' ' + item.executorInfo.nickname }}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-else-if="item.approval_status == '0'"
                  >
                    <span class="step_row_uesername_for" v-for="itemsss in item.tomemberInfo">
                      <span v-if="itemsss.nickname">{{itemsss.nickname}}</span>
                    </span>
                  </p>
                  <p style="width:45%" v-else></p>
                  <p
                    class="overflowHiddenText"
                    style="width:13%;display:flex;justify-content: flex-end; color:#128BF1;margin-left:30px"
                  >
                    <span style="color: rgb(48, 173, 95)" v-if="item.approval_status=='0'">待审批</span>
                    <span style="color:rgb(18, 139, 241)" v-if="item.approval_status=='1'">通过</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-1'">驳回</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-2'">撤回</span>
                  </p>
                </div>
                <p v-if="item.remark" style="margin-bottom:20px;padding-left: 50px;font-size:16px">
                  <span>备注:</span>
                  <span style="margin-left:15px;color:rgb(255, 51, 51)">{{item.remark}}</span>
                </p>
              </div>
            </div>
          </el-timeline-item>
          <!-- file (只是申请项目编号时不展示) -->
          <el-timeline-item
            v-if="!is_demand_type"
            :class="projectLog.file.length>0?'eltimelinefocus':'eltimelineNofocus'"
            timestamp="存档"
            placement="top"
          >
            <div v-for="items in projectLog.file">
              <div v-for="item in items">
                <div class="stepItem" style="width:80%">
                  <p
                    class="overflowHiddenText"
                    style="width:37%"
                  >{{item.stage_code_show.split('-')[1]}}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-if="item.approval_status != '0' && item.executorInfo"
                  >{{item.add_time+' ' + item.executorInfo.nickname }}</p>
                  <p
                    class="overflowHiddenText"
                    style="width:45%; text-align:right;"
                    v-else-if="item.approval_status == '0'"
                  >
                    <span class="step_row_uesername_for" v-for="itemsss in item.tomemberInfo">
                      <span v-if="itemsss.nickname">{{itemsss.nickname}}</span>
                    </span>
                  </p>
                  <p style="width:45%" v-else></p>
                  <p
                    class="overflowHiddenText"
                    style="width:13%;display:flex;justify-content: flex-end; color:#128BF1;margin-left:30px"
                  >
                    <span style="color: rgb(48, 173, 95)" v-if="item.approval_status=='0'">待审批</span>
                    <span style="color:rgb(18, 139, 241)" v-if="item.approval_status=='1'">通过</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-1'">驳回</span>
                    <span style="color:rgb(255, 51, 51)" v-if="item.approval_status=='-2'">撤回</span>
                  </p>
                </div>
                <p v-if="item.remark" style="margin-bottom:20px;padding-left: 50px;font-size:16px">
                  <span>备注:</span>
                  <span style="margin-left:15px;color:rgb(255, 51, 51)">{{item.remark}}</span>
                </p>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
    <!-- 项目进度弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleStep"
      width="60%"
      :before-close="handleStepClose"
      class="stepDia"
      @close="handleStepClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <!-- <span class="title-name" style="color:#128BF1;margin-right:5px">张某某-</span> -->
        <span class="title-age">调整项目阶段</span>
      </div>
      <div class="stepChangeBox">
        <el-form
          ref="form"
          :model="ckeckProjectStepData"
          label-position="right"
          label-width="160px"
        >
          <div class="diaForm_box">
            <div style="box-sizing:border-box;padding:0">
              <!-- 项目名称 -->
              <el-form-item label="项目名称:" style="margin-bottom:0px;">
                <span style="color:#666;font-size:16px">{{ckeckProjectStepData.project_name}}</span>
              </el-form-item>
              <!-- 项目阶段 -->
              <el-form-item label="项目阶段:" style="margin-bottom:0px;">
                <span style="color:#666;font-size:16px">{{ckeckProjectStepData.project_status_show}}</span>
              </el-form-item>
              <!-- 项目登记人 -->
              <el-form-item
                label="项目登记人:"
                style="margin-bottom:0px;"
                v-if="ckeckProjectStepData.memberInfo"
              >
                <span
                  v-if="ckeckProjectStepData.memberInfo"
                  style="color:#666;font-size:16px"
                >{{ckeckProjectStepData.memberInfo.nickname}}</span>
              </el-form-item>
              <!-- 项目编号 -->
              <el-form-item label="项目编号:" style="margin-bottom:0px;">
                <span style="color:#666;font-size:16px">{{ckeckProjectStepData.project_code}}</span>
              </el-form-item>

              <!-- 调整项目阶段 -->
              <el-form-item label="调整项目阶段:" style="margin-bottom:30px">
                <el-select style="width:70%" v-model="changeCode" filterable placeholder="请选择">
                  <el-option
                    v-for="item in selectStepList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- 报销新增按钮 -->
        <el-button style="background-color: #ccc;" @click="handlecancleClick">取 消</el-button>
        <el-button type="primary" @click="handleEditStepSbumitClick">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'projectIndex',
  data() {
    return {
      changeCode: '',
      member_id: '',
      token: '',
      project_status: '',
      company_id: '',
      cache_department_id: '',
      dialogVisible: false,
      hoverId: '',
      activeDorpList: '',
      projectActive: '1',
      searchInfo: '',
      currentPage: 1,
      Total: 0,
      pageSize: 10,
      projectLog: {
        reg: {},
        scene: {},
        audit: {},
        seal: {},
        out: {},
        file: {},
      },
      ckeckProjectStepData: {},
      projectList: [],
      PorjectType: '',
      projectBstatus: '',
      listInfo1: [],
      listInfo2: [],
      dialogVisibleStep: false,
      ckeckProjectStepId: '',
      selectStepList: [],
      is_demand_type: false,
    }
  },
  methods: {
    async handleEditStepSbumitClick() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('project_id', this.ckeckProjectStepId)
      param.append('stage_code', this.changeCode)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/adjust_node',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisibleStep = false
    },
    async handleChangeStepClick() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('project_id', this.ckeckProjectStepId)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/adjust_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.selectStepList = res.datas.list
      console.log('获取项目可调整的大阶段', this.selectStepList)
      this.dialogVisibleStep = true
    },
    // *点击查看进度
    async checkStep(item) {
      // 判断是否申请项目编号
      if (item.demand_type == '2') {
        this.is_demand_type = true
      } else {
        this.is_demand_type = false
      }
      // return console.log('item', item)
      this.ckeckProjectStepId = item.project_id
      this.ckeckProjectStepData = item
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('project_id', item.project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/get_approval_log_all',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectLog = res.datas
      console.log('项目进度', this.projectLog)
      this.dialogVisible = true
    },

    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.ckeckProjectStepId = ''
      this.changeCode = ''
      this.ckeckProjectStepData = {}
    },
    handleStepClose(done) {
      this.dialogVisibleStep = false
    },
    handleStepClosed() {
      // this.ckeckProjectStepId = ''
      // this.changeCode = ''
      // this.ckeckProjectStepData = {}
    },
    handlecancleClick() {
      this.dialogVisibleStep = false
    },
  },
  // activated() {
  //   this.getProjectTypeList()
  //   console.log('activatedactivatedactivatedactivatedactivated')
  // },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
  },
  watch: {},
}
</script>
<style lang="less" scoped>
.diaForm_box {
  width: 100%;
  padding-left: 50px;
  box-sizing: border-box;
  /deep/.el-form-item__content {
    line-height: 36px;
  }
  /deep/.el-form-item__label {
    line-height: 36px;
    font-size: 16px;
    color: #333;
  }
  /deep/.labelFormItem {
    /deep/.ProjectType {
      width: 80%;
      flex-wrap: wrap;
      height: initial;
      max-height: 105px;
      overflow-y: auto;
      /deep/.el-radio {
        // width: 30%;
        height: 35px;
      }
      /deep/.el-checkbox {
        width: 20%;
        .el-checkbox__label {
          font-size: 16px;
          font-weight: normal;
        }
      }
    }
  }
  .inputTwoRow {
    box-sizing: border-box;
    // padding: 0 16%;
    // padding-right: 14%;
    width: 100%;
    display: flex;
    /deep/.el-form-item:nth-child(2) {
      margin-left: 10%;
    }
    /deep/.el-input__inner {
      width: 100%;
    }
  }
  .diaFormTitle {
    width: 100%;
    font-weight: bold;
    color: #128bf1;
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .diaFormTitle::before {
    content: '';
    display: block;
    width: 3px;
    height: 16px;
    background-color: #40a0f2;
    margin-right: 5px;
  }
  .diaFormTitle1 {
    width: 100%;
    font-weight: bold;
    color: #128bf1;
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .diaFormTitle1 span {
    display: flex;
    align-items: center;
  }
  .diaFormTitle1 span::before {
    content: '';
    display: block;
    width: 3px;
    height: 16px;
    background-color: #40a0f2;
    margin-right: 5px;
  }
}
.dialog-footer {
  width: 100%;
  display: flex;
  padding-left: 30%;
  .el-button {
    // width: 180px;
    width: 23%;
    height: 45px;
    padding: 0;
    font-size: 18px;
    font-weight: normal;
    color: #fff;
    border: none;
    border-radius: 25px;
    background-color: #40a0f2;
    margin-bottom: 10px;
  }
  .el-button:first-child {
    margin-right: 5%;
  }
}

// 修改时间线样式
/deep/ .projectTime {
  margin-left: 100px;
  .el-timeline-item__content {
    padding: 20px 0 0px;
  }
  /deep/.el-timeline-item__timestamp.is-top {
    font-size: 18px;
    color: #128bf1;
    font-weight: 700;
    padding-top: 0;
  }
  .stepItem {
    display: flex;
    box-sizing: border-box;
    padding-left: 50px;
    margin-bottom: 15px;
    p {
      font-size: 16px;
    }
  }

  .overflowHiddenText {
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*不换行*/
    text-overflow: ellipsis; /*超出部分文字以...显示*/
  }
  .step_row_uesername_for {
    margin-right: 5px;
  }

  // 半透明圆环
  .eltimelinefocus {
    // 线
    .el-timeline-item__tail {
      border-color: #40a0f2;
    }
    .el-timeline-item__node {
      // border: 3px solid hsla(0, 0%, 90%, 0.8);
      border: 3px solid #cbe0ff;
      background-clip: content-box;
      background: rgba(78, 151, 255, 1);
    }
    .el-timeline-item__node--normal {
      left: -3px;
      top: -3px;
      width: 11px;
      height: 11px;
    }
  }
  // 半透明圆环
  .eltimelineNofocus {
    // 线
    .el-timeline-item__tail {
      border-left: 2px dashed #e3e3e3;
    }
    .el-timeline-item__node {
      // border: 3px solid hsla(0, 0%, 90%, 0.8);
      border: 3px solid #efefef;
      background-clip: content-box;
      background: #ddd;
    }
    .el-timeline-item__node--normal {
      left: -3px;
      top: -3px;
      width: 11px;
      height: 11px;
    }
  }
}
// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
}
.stepDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
  }
}
.table__body::-webkit-scrollbar {
  width: 5px !important;
}
.table__body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.table__body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
/deep/.diaHistoryBox {
  height: 70vh;
  overflow-y: auto;
  .projectTime {
    padding: 10px 0;
  }
}
.configRow {
  display: flex;
  justify-content: flex-end;
  .el-button {
    font-size: 16px;
    font-weight: normal;
    border: none;
    width: 150px;
    height: 40px;
    background: rgb(64, 160, 242);
    color: #fff;
    border-radius: 24px;
    padding: 0;
    margin-left: 30px;
  }
}
</style>
